import { render } from "./SelectHeader.vue?vue&type=template&id=5c2411e1&scoped=true"
import script from "./SelectHeader.vue?vue&type=script&lang=js"
export * from "./SelectHeader.vue?vue&type=script&lang=js"

import "quill-emoji/dist/quill-emoji.css?vue&type=style&index=0&lang=css"
import "./SelectHeader.vue?vue&type=style&index=1&id=5c2411e1&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2411e1"]])

export default __exports__